"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.calculateTotalPages = void 0;

var _preact = require("preact");

var _PageInfo = _interopRequireDefault(require("./PageInfo"));

var _Pager = _interopRequireDefault(require("./Pager"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _PageSizeSelector = _interopRequireDefault(require("./PageSizeSelector"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ChevronLeft = _interopRequireDefault(require("@insided/shared/icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/shared/icons/ArrowDropdown"));

var calculateTotalPages = function calculateTotalPages(total, pageSize) {
  return Math.ceil(total / pageSize);
};

exports.calculateTotalPages = calculateTotalPages;

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      total = _ref.total,
      pageSize = _ref.pageSize,
      pageSizes = _ref.pageSizes,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      displayListUpwards = _ref.displayListUpwards;
  var totalPages = calculateTotalPages(total, pageSize);
  var start = currentPage * pageSize - pageSize + 1;
  var end = start - 1 + (currentPage === totalPages && total % pageSize !== 0 ? total % pageSize : pageSize);
  var isEqualOrOverTenThousand = total >= 10000;
  return (0, _preact.h)("div", {
    className: "control-pagination"
  }, (0, _preact.h)("span", {
    className: "control-pagination--info"
  }, start, "-", end, " of ", total, isEqualOrOverTenThousand && '+', " results", isEqualOrOverTenThousand && (0, _preact.h)(_Tooltip.default, {
    trigger: (0, _preact.h)(_Question.default, {
      width: 16,
      height: 16
    }),
    tooltipMessage: "We limit the results to 10,000 to ensure speedy loading times \u26A1",
    withArrow: true,
    position: "center",
    noWrap: true,
    top: 24
  })), (0, _preact.h)(_Pager.default, {
    isDisabled: currentPage === 1,
    onClick: function onClick() {
      return onPageChange(1);
    },
    customClass: "qa-pager-first"
  }, (0, _preact.h)("a", null, "First")), (0, _preact.h)(_Pager.default, {
    "data-qa": "pagination-prev-page",
    isDisabled: currentPage === 1,
    isChevron: true,
    onClick: function onClick() {
      return onPageChange(currentPage - 1);
    }
  }, (0, _preact.h)(_ChevronLeft.default, {
    width: 16,
    height: 16
  })), (0, _preact.h)(_PageInfo.default, {
    currentPage: currentPage,
    totalPages: totalPages,
    onPageChange: onPageChange
  }), (0, _preact.h)(_Pager.default, {
    "data-qa": "pagination-next-page",
    isDisabled: currentPage === totalPages,
    isChevron: true,
    onClick: function onClick() {
      return onPageChange(currentPage + 1);
    }
  }, (0, _preact.h)(_ChevronRight.default, {
    width: 16,
    height: 16
  })), (0, _preact.h)(_Pager.default, {
    isDisabled: currentPage === totalPages,
    onClick: function onClick() {
      return onPageChange(totalPages);
    },
    customClass: "qa-pager-last"
  }, (0, _preact.h)("a", null, "Last")), (0, _preact.h)(_DropdownControl.default, {
    closeOnDropdownClick: true,
    displayListUpwards: displayListUpwards,
    align: "adjust",
    trigger: function trigger(isOpen) {
      return (0, _preact.h)(_Button.default, {
        "data-qa": "pagination--page-selector",
        title: "".concat(pageSize, " rows"),
        className: "control-pagination--page-selector",
        icon: (0, _preact.h)(_ArrowDropdown.default, {
          width: 24,
          height: 24,
          className: isOpen ? 'dropdown-icon--open' : ''
        })
      });
    },
    items: (0, _PageSizeSelector.default)(pageSizes, onPageSizeChange)
  }));
};

var _default = Pagination;
exports.default = _default;